export default "__VITE_ASSET__BposPqYP__"